// src/components/attorneys/AttorneyCard.jsx
import { motion } from "framer-motion";
import StarRating from "./StarRating";

const AttorneyCard = ({ attorney, onOpenTicket }) => {
  const rating = parseFloat(attorney.average_rating || "0");
  const hasReviews = attorney.total_ratings > 0;

  return (
    <motion.div
      layout
      whileHover={{ y: -4, boxShadow: "0px 14px 35px rgba(30, 64, 175, 0.12)" }}
      className="h-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm hover:shadow-md"
    >
      <div className="flex flex-col h-full">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{attorney.name}</h3>
          <a href={`mailto:${attorney.email}`} className="mt-1 inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-700">
            {attorney.email}
          </a>
        </div>

        <div className="mt-4 flex items-center justify-between">
          <StarRating rating={rating} />
          <span className="text-xs font-semibold text-blue-600">{rating.toFixed(2)}</span>
        </div>
        <p className="mt-1 text-sm text-gray-500">
          {hasReviews
            ? `${rating.toFixed(1)} · ${attorney.total_ratings} review${attorney.total_ratings === 1 ? "" : "s"}`
            : "No reviews yet"}
        </p>

        {attorney.office && (
          <div className="mt-4 rounded-xl border border-blue-100 bg-blue-50/60 p-4">
            <p className="text-sm font-semibold text-blue-700">{attorney.office.name}</p>
            <p className="text-xs text-blue-600 mt-1">{attorney.office.city}, {attorney.office.state}</p>
            <p className="text-xs text-blue-600 mt-1">{attorney.office.address}</p>
            {attorney.office.phone && (
              <a href={`tel:${attorney.office.phone}`} className="mt-2 inline-flex items-center text-xs font-semibold text-blue-700 hover:text-blue-800">
                {attorney.office.phone}
              </a>
            )}
          </div>
        )}

        <div className="mt-6 flex flex-wrap gap-3">
          <button
            onClick={() => onOpenTicket(attorney.id)} // تمرير الـ ID
            className="inline-flex items-center justify-center rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700"
          >
            Open Ticket
          </button>
          {attorney.office?.phone && (
            <a
              href={`tel:${attorney.office.phone}`}
              className="inline-flex items-center justify-center rounded-full border border-blue-600 px-4 py-2 text-sm font-semibold text-blue-600 hover:bg-blue-50 transition"
            >
              Call Office
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default AttorneyCard;